import React from "react";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";

const BreachOpenCaseConfirmation = ({ closeDialog, handleConfirm, type }: any) => {
    return (
        <div>
            <div className="dialog-header">
                <div className="dialog-icon">
                    <RenderIcons iconName="briefcase" />
                </div>
                {type === "NOT_MINE" ? (
                    <h3 className="content-sub-title">Resolve Case Confirmation</h3>
                ) : (
                    <h3 className="content-sub-title">Open Case Confirmation</h3>
                )}
            </div>
            <div className="dialog-body">
                {type === "NOT_MINE" ? (
                    <p>
                        Please confirm that you'd like to resolve this case. We'll be here if you're ever concerned about this case in future. Reopen your case and
                        connect with your Resolution Specialist at any time.
                    </p>
                ) : (
                    <p>Please confirm that you'd like to open a case for the selected alert and your certified Resolution Specialist will contact you shortly.</p>
                )}
            </div>
            <div className="dialog-footer">
                <div className="row between-xs">
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button onClick={closeDialog} type="button" className="btn-default btn-link">
                            <span className="btn-text">Close</span>
                        </button>
                    </div>
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button
                            type="button"
                            className={`btn-default btn-primary`}
                            onClick={() => {
                                window.addToDataLayer({ event: "breachIQBtnConfirmCase" });
                                handleConfirm();
                            }}
                        >
                            <span className="btn-text">{type === "NOT_MINE" ? "Resolve Case" : "Open Case"}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BreachOpenCaseConfirmation;
